var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFailedActivation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 188,
    viewBox: "0 0 188 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M94 188c51.915 0 94-42.085 94-94S145.915 0 94 0 0 42.085 0 94s42.085 94 94 94z",
    fill: "#E24C4B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hzh6tu36aa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.5 140c25.129 0 45.5-20.371 45.5-45.5S119.629 49 94.5 49 49 69.371 49 94.5 69.371 140 94.5 140z",
    fill: "#88A13B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m82.875 115.025 23.396 23.396c19.377-5.167 33.73-22.821 33.73-43.92v-1.293l-18.372-16.936-38.754 38.753z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.804 106.536c2.01 2.009 2.01 5.454 0 7.463L91.5 116c-2.01 2.009-5.454 2.009-7.464 0L65.808 97.628c-2.01-2.01-2.01-5.454 0-7.464l2.303-2c2.01-2.01 5.455-2.01 7.464 0l18.229 18.372z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.037 74.425c2.009-2.01 5.454-2.01 7.463 0l2.707 2.708c2.009 2.01 2.009 5.454 0 7.464L91.63 116.03c-2.01 2.009-5.455 2.009-7.464 0l-2.707-2.708c-2.01-2.01-2.01-5.455 0-7.464l31.578-31.434z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ost0xfohtb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140 94.5c0 12.105-4.7 23.498-13.232 32.081-8.528 8.576-19.88 13.341-31.97 13.417-.03 0-.062.002-.092 0-.067.002-.137.002-.206.002-12.152 0-23.578-4.731-32.172-13.327C53.733 118.08 49 106.653 49 94.5c0-12.153 4.733-23.578 13.328-32.173C70.922 53.733 82.348 49 94.5 49c.07 0 .137 0 .206.002.032 0 .064 0 .096.002 12.088.078 23.439 4.841 31.966 13.417C135.3 71.004 140 82.396 140 94.5z",
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M140 94.5c0 12.105-4.7 23.498-13.232 32.081-8.528 8.576-19.88 13.34-31.97 13.417-.03 0-.062.002-.092 0V49.002l.096.001c12.088.079 23.439 4.842 31.966 13.418C135.3 71.004 140 82.396 140 94.5z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.307 75.744v20.34c0 4.181-3.4 7.582-7.58 7.582h-.02c-1.953-.057-3.969-.846-5.342-2.22a7.536 7.536 0 0 1-2.22-5.362v-20.34c0-4.134 3.432-7.463 7.562-7.582h.02c4.18 0 7.58 3.402 7.58 7.582z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.724 103.666c-.062 0 .062.001 0 0z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.903 113.275a7.184 7.184 0 0 1-7.177 7.177h-.018c-3.948-.009-7.157-3.225-7.157-7.177 0-3.951 3.21-7.166 7.157-7.175h.018c3.958 0 7.177 3.218 7.177 7.175z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.902 113.277a7.184 7.184 0 0 1-7.177 7.177h-.018v-14.352h.018c3.958 0 7.177 3.218 7.177 7.175zM102.308 75.744v20.34c0 4.181-3.401 7.582-7.581 7.582h-.02V68.162h.02c4.18 0 7.581 3.402 7.581 7.582z",
    fill: "#DDEBF0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#23rvig5wzc)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.444 140c25.099 0 45.445-20.346 45.445-45.444 0-25.099-20.346-45.445-45.445-45.445C69.346 49.111 49 69.457 49 94.556 49 119.654 69.346 140 94.444 140z",
    fill: "#E24C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.889 94.556c0 24.994-20.45 45.444-45.445 45.444-14.485 0-27.266-6.532-35.503-17.041 7.669 6.248 17.61 9.941 28.403 9.941 24.994 0 45.444-20.45 45.444-45.445 0-10.793-3.692-20.733-9.941-28.402 10.509 8.236 17.042 21.017 17.042 35.503z",
    fill: "#D1403F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.18 115.289c-1.705 1.704-4.545 1.704-6.249 0l-14.485-14.485-14.486 14.485c-1.704 1.704-4.544 1.704-6.248 0-1.704-1.704-1.704-4.545 0-6.249l14.485-14.485L73.712 80.07c-1.704-1.704-1.704-4.545 0-6.249 1.704-1.704 4.544-1.704 6.248 0l14.486 14.485 14.485-14.485c1.704-1.704 4.544-1.704 6.249 0 1.704 1.704 1.704 4.545 0 6.249l-14.486 14.485 14.486 14.485c1.704 1.704 1.704 4.545 0 6.249z",
    fill: "#fff"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hzh6tu36aa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(49 49)",
    d: "M0 0h91v91H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ost0xfohtb"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(49 49)",
    d: "M0 0h91v91H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "23rvig5wzc"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(49 49.111)",
    d: "M0 0h90.889v90.889H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedActivation);
export default __webpack_public_path__ + "static/media/FailedActivation.ce57637e2403ac49d90707c35590dee4.svg";
export { ForwardRef as ReactComponent };